import { createFileRoute, redirect } from '@tanstack/react-router';
import { meQuery } from '@/lib/queries';
import { useUi } from '@/stores/ui';

/** Sends people to the right place: login, onboarding, or their last workspace. */
export const Route = createFileRoute('/')({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQuery);
    if (!me) throw redirect({ to: '/login' });
    if (me.workspaces.length === 0) throw redirect({ to: '/onboarding' });
    const last = useUi.getState().lastWorkspaceId;
    const workspace = me.workspaces.find((w) => w.id === last) ?? me.workspaces[0]!;
    throw redirect({ to: '/w/$workspaceId/home', params: { workspaceId: workspace.id } });
  },
});
